import React from "react";
import { Row, Col } from "react-bootstrap";
import styles from "../components/Categories.scss";

const Categories = props => {
  const list = props.list;
  const element = list.map(categories => (
    <Col
      xs={12}
      sm={4}
      key={categories.toString()}
      className={styles.categories}
    >
      {categories.map(category => (
        <span key={category.toString()} className={styles.categoriesItem}>
          {category}
        </span>
      ))}
    </Col>
  ));

  return <Row>{element}</Row>;
};

export default Categories;



// WEBPACK FOOTER //
// ./src/routes/candidate/signUpMarketing2/components/Categories.js